<div class="assets table-container">
    <div class="search-container">
        <div class="row-flex">
            <app-search-input
                [placeholder]="('search' | i18next: { format: 'capitalize' }) + '...'"
                [inputStr]="currentAssetRuleApiParams.search || ''"
                (inputChanged)="inputChanged($event)"
            ></app-search-input>
            <app-rule-filter
                [companyId]="selectedCompanyId$ | async"
                (ruleIds)="getRuleIds($event)"
                context="rule-filter assets"
            ></app-rule-filter>
            <app-division-filter (divisionIds)="getDivisionIds($event)"></app-division-filter>
        </div>
        <div>
        <div class="row-flex">
            <app-action-button
                class="clear-rule"
                title="clear rule"
                [disabled]="!selectedRows.length"
                (buttonClicked)="clearRuleClick()"
            ></app-action-button>

            <app-action-button
                title="assign rule"
                [disabled]="!selectedRows.length"
                (buttonClicked)="assignRuleClick()"
            ></app-action-button>
        </div>

        </div>

    </div>


    <div class="header">
        <h2 class="heading-3">{{ "asset list" | i18next: { format: "capitalize" } }}</h2>
        <p>{{ "assets selected" | i18next: { count: selectedRows?.length || 0 } }}</p>
    </div>

    <ng-container *ngIf="getDataSource().data?.length > 0; else noData" >
        <app-table
            [dataSource]="getDataSource()"
            [view]="view"
            [activeRowId]="clickedRule?.id"
            activeRowIdKey="ruleId"
            [sortActive]="sortActive"
            [sortDirection]="sortDirection"
            (sortChange)="onMatSortChange($event)"
            (selectedRows)="selectedRowsReceived($event)"
            (sortObjChanged)="receiveSortObj($event)"
            (rowClicked)="onRowClick($event)"
            checkboxText="SELECT ASSETS"
        >
            <app-column
                name="asset name"
                id="assetName"
                sortable="true"
                data="assetName"
                view="assets"
            >
            </app-column>
            <app-column
                name="division name"
                id="divisionName"
                sortable="true"
                data="divisionName"
                view="assets"
            >
            </app-column>
            <app-column
                name="rule name"
                id="ruleName"
                sortable="true"
                data="ruleName"
                view="assets"
            >
            </app-column>

        </app-table>

        <app-paginator
            [length]="paginatorLength"
            [page]="currentAssetRuleApiParams.page || '1'"
            [pageSizeOptions]="pageSizeOptions"
            (pageQueryChange)="pageQueryChange($event)"
        ></app-paginator>
    </ng-container>

    <ng-template #noData>
        <p *ngIf="!error">{{ "there are no assets" | i18next }}</p>
    </ng-template>


    <p *ngIf="error">{{ "an error occurred fetching the data" | i18next }}</p>

 </div>


 <ng-template #assetRuleErrors>
    <p class="evir-font-default">{{ errorMessage }}</p>
</ng-template>





